import { Address } from "@data/schema/loan-appication/address";

export class ReferenceContact {
  sAddress: Address;
  sContactName: string;
  sRelationShip: string;
  sEmail: string;
  sPhone: string;
}
